import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SendMessageForm } from 'src/app/shared/interfaces';

import { Repository } from './repository';
import { SendMessageApi } from '../api/send-message-api';

@Injectable({
  providedIn: 'root',
})
export class SendMessageRepository extends Repository {
  constructor(private sendMessageApi: SendMessageApi) {
    super();
  }

  sendMessage(form: SendMessageForm): Observable<string> {
    return this.sendMessageApi.sendMessage(form);
  }
}
